export function mapMenuToPermission(menus: any[]) {
  const permissions: string[] = []

  // 递归映射
  function recurseGetPermission(menuList: any[]) {
    for (const item of menuList) {
      if (item.type === 3) {
        // 第三层数组(最底层)
        permissions.push(item.permission)
      } else {
        recurseGetPermission(item.children ?? [])
      }
    }
  }
  recurseGetPermission(menus)

  return permissions
}
